<template>
     <div class="modal fade text-left" id="appointmentModal" tabindex="3" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="appointmentModal">{{ $t("labels.selectedAppointment") }} </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                  <form class="form">
                    <appointment-form :appointment="appointment" ref="appointmentForm"></appointment-form>
                    <div class="form-actions">
                      <button type="button" class="btn btn-success" @click.prevent="saveAppointment($refs.appointmentForm.clonedAppointment)">
                        <i class="icon-note"></i> {{ $t("labels.save") }}
                      </button>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeNewAppointmentModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppointmentForm from './AppointmentForm'
import AppointmentService from '@/services/appointment'
import moment from 'moment'

export default {
    props: ['patient'],
    components: {
        AppointmentForm
    },
    data() {
        return {
            appointment: {
                date: '',
                description: '',
                location: '',
                notifyBy: '',
                notifyWhen: '',
                periodic: false,
                startDate: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
                endDate: '',
                periodStep: 'weeks',
                periodStart: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
                periodEnd: moment(new Date()).add(30, 'days').endOf('day').format('YYYY-MM-DD'),
                dayOfWeek: 1,
                dailyStart: '8:00',
                dailyEnd: '',
                dayType: 'sameday',
                dayOfMonth: 1,
                weekOfMonth: 1,
                dayOfWeek: 1
            }
        }
    },
    methods: {
        saveAppointment: async function(appointment) {
            this.errors = []
            if (!appointment.startDate) {
                this.errors.push(this.$t("errors.dateRequired"))
            }
            //if (this.appointment.type.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.type")]))
            //}
            //if (this.appointment.description.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.description")]))
            //}
            if (appointment.location.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.location")]))
            }
            //if (this.appointment.notifyBy.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.notifyBy")]))
            //}
            //if (this.appointment.notifyWhen.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.notifyWhen")]))
            //}
            if (this.errors.length === 0) {
                appointment.patientId = this.patient._id
                let result = await AppointmentService.create(appointment)
                if (result) {
                    this.$refs.closeNewAppointmentModal.click()
                    this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.appointment")]))
                    this.appointment = {
                        date: '',
                        description: '',
                        location: '',
                        notifyBy: '',
                        notifyWhen: '',
                        periodic: false,
                        startDate: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
                        endDate: '',
                        periodStep: 'weeks',
                        periodStart: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
                        periodEnd: moment(new Date()).add(30, 'days').endOf('day').format('YYYY-MM-DD'),
                        dayOfWeek: 1,
                        dailyStart: '8:00',
                        dailyEnd: '',
                        dayType: 'sameday',
                        dayOfMonth: 1,
                        weekOfMonth: 1,
                        dayOfWeek: 1
                    }
                    this.$emit('updateappointments')
                } else {
                    this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
        }
    }
}
</script>
